import { render } from "./PanelProductAwards.vue?vue&type=template&id=4ce74b38&scoped=true"
import script from "./PanelProductAwards.vue?vue&type=script&lang=js"
export * from "./PanelProductAwards.vue?vue&type=script&lang=js"

import "./PanelProductAwards.vue?vue&type=style&index=0&id=4ce74b38&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce74b38"]])

export default __exports__